import React from 'react';
import { TIMINGS, PAYERS, KINDS, MEAL_GROUPINGS } from './constants';
import MealsComponent from './components';
import camelCase from 'lodash/camelCase';

export type TimingType = ?$Values<typeof TIMINGS>;
export type PayerType = ?$Values<typeof PAYERS>;
export type KindType = ?$Values<typeof KINDS>;
export type MealGroupingType = ?$Values<typeof MEAL_GROUPINGS>;

export type MealProps = {
  id: ?number,
  planMealId: ?number,
  timing: TimingType,
  payer: PayerType,
  kind: KindType,
  description: ?string,
};

type MealsProps = {
  meals: Array<MealProps>,
  mealGrouping: MealGroupingType,
};

const Meals = ({ meals = [], mealGrouping }: MealsProps) => (
  <MealsComponent meals={meals} mealGrouping={camelCase(mealGrouping)} />
);

export default Meals;
